<template>
  <div class="items-list" v-bind:class="{ inner: isInnerList }">
    <div v-for="item in items">
      <a class="card-link" :title="item.name" @click="setCurrentItem(item, $event)">
        <b-card no-body
                :bg-variant="isCurrentItem(item) ? 'light' : ''"
                :border-variant="isCurrentItem(item) ? 'primary' : 'light'"
                class="individual-item">
          <p class="card-text">
            <input type="checkbox"
                   class="prevent-this-click"
                   v-if="item.type.endsWith('requirement')"
                   :value="item"
                   v-model="selectedRequirements">
            <icon :name="item.type === 'requirement' ? 'file-text-o' : 'folder-o'" :class="getIconClass(item)" style="vertical-align: middle;"></icon>
            <span v-if="item.type === 'requirement'"
                  class="my-card-text listview-item-id">{{item.prefix + getID(item)}}</span>
            <span v-else
                  class="my-card-text listview-item-name">{{item.name}}</span>
            <span v-if="item.has_descendant_folders || item.has_descendant_requirements" @click="toggle(item)">
        <icon
          :name="isExpandedFolder(item) ? 'minus-square-o' : 'plus-square-o'"
          class="prevent-this-click"
          style="vertical-align: middle;">
        </icon>
        </span>
            <span v-if="item.type === 'requirement'">
            <br>
            <span class="my-card-text listview-item-name">{{item.name}}</span>
          </span>
          </p>
        </b-card>
      </a>
      <items-list
        :items="item.descendants"
        :selectedRequirements="selectedRequirements"
        v-show="openFolderIds && openFolderIds.hasOwnProperty(item.folder_id)"
        v-if="item.descendants"
        isInnerList="true">
      </items-list>
    </div>
  </div>
</template>

<script>
import DeleteRequirementModal from '@/components/modals/DeleteRequirementModal'
import MoveRequirementModal from '@/components/modals/MoveRequirementModal'
import utilsMixin from '@/mixins/utils'
export default {
  components: { DeleteRequirementModal, MoveRequirementModal },
  name: 'items-list',
  watch: {
    selectedRequirements (newValue, oldValue) {
      // Get the diffed items
      let addedRequirements = newValue.filter(h => !oldValue.includes(h))
      let deletedRequirements = oldValue.filter(h => !newValue.includes(h))
      if (addedRequirements.length > 0) {
        this.$store.commit('addSelectedRequirement', addedRequirements)
      } else if (deletedRequirements.length > 0) {
        this.$store.commit('deleteSelectedRequirement', deletedRequirements)
      }
    }
  },
  data () {
    return {
      selectedRequirements: []
    }
  },
  props: {
    items: Array,
    isInnerList: false
  },
  computed: {
    currentProject () {
      return this.$store.state.currentProject
    },
    currentItem () {
      return this.$store.state.currentItem
    },
    openFolderIds () {
      return this.$store.state.openFolderIds
    }
  },
  mixins: [utilsMixin],
  methods: {
    isCurrentItem (item) {
      if (this.currentItem) {
        if (item.type.endsWith('requirement')) {
          return item.requirement_id === this.currentItem.requirement_id
        } else {
          return item.folder_id === this.currentItem.folder_id
        }
      }
    },
    getIconClass (item) {
      if (item.type === 'requirement') {
        if (item.category === 'LOW_LEVEL') {
          return 'text-secondary'
        } else if (item.category === 'HIGH_LEVEL') {
          return 'text-primary'
        } else {
          return 'text-info'
        }
      }
      return 'text-primary'
    },
    isExpandedFolder (item) {
      return item.type === 'folder' && this.openFolderIds && this.openFolderIds.hasOwnProperty(item.folder_id)
    },
    toggle (item) {
      if (this.openFolderIds.hasOwnProperty(item.folder_id)) {
        this.$store.commit('deleteOpenFolder', item.folder_id)
      } else {
        this.$store.commit('addOpenFolder', item.folder_id)
        this.getFolderDescendants(item)
      }
    },
    getFolderDescendants (folder) {
      this.$http.get(
        '/api/item/' + folder.folder_id + '/descendant?atlassian_project_id=' + this.currentProject.id
      ).then(response => {
        // Using $set to be able to add a new property that wasn't there before, to get around a JS limitation
        // See https://vuejs.org/v2/guide/reactivity.html#Change-Detection-Caveats
        this.$set(folder, 'descendants', response.data.items)
      }, response => {
        console.log('error')
      })
    },
    getID (requirement) {
      return requirement.display_id ? requirement.display_id : requirement.requirement_id
    },
    setCurrentItem (item, event) {
      let target = event.target
      if (event.target.tagName === 'path') {
        target = event.target.parentNode
      }
      if (!target.classList.contains('prevent-this-click')) {
        this.pushTheState(item)
      }
    },
    pushTheState (item) {
      let itemType = ''
      let itemId = ''
      if (item.type.endsWith('requirement')) {
        itemType = 'requirements'
        itemId = item.requirement_id
      } else if (item.type === 'folder') {
        itemType = 'folder'
        itemId = item.folder_id
      }
      window.AP.history.pushState(`${this.currentProject.id}-${itemType}-${itemId}`)
    }
  }
}
</script>

<style>
.items-list {
  font-size: 14px;
}
.items-list .inner {
  margin-left: 1.5em;
}
.items-list a {
  cursor: pointer;
}
.individual-item {
  display: flex;
}
.individual-item a {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: .5em;
  margin-right: .5em;
}
.individual-item a:hover {
  text-decoration: underline !important;
}
.individual-item label {
  margin-bottom: 0;
}
.individual-item label.custom-control {
  min-height: 0;
  margin-right: 0;
}
.listview-item-name {
  font-size: 13px;
}
.listview-item-id {
  font-weight: 600;
  font-size: 12px;
}
a.card-link:hover .my-card-text{
  text-decoration: underline;
}
</style>



// WEBPACK FOOTER //
// ItemsList.vue?2ed64d24